import type { StockRow } from '@econtractor/types';
import EmptyResult from "components/others/EmptyResult";
import StockTableRows from "./StockTableRows";
import type { StockLotRow } from './OffStockLots/StockLotsTable/types';
import { useWarehouse } from './context/WarehouseProvider';

interface WarehouseTableBodyProps {
    wId: number | string;
    stocksList: StockRow[] | null;
    setShowTransfer: (show: boolean | number | 'all') => void;
    setShowComing: (show: boolean | number) => void;
    setShowPaymentsId: (id: number | null) => void;
    setShowPaymentsTitle: (title: string | null) => void;
    setShowStockLots?: (stock: StockRow | null) => void;
    stockLots?: Record<number, StockLotRow[]> | null;
    fetchStocks?: (force?: boolean) => Promise<unknown> | unknown;
    onlyView: boolean;
    showBalanceColumn?: boolean;
}

const WarehouseTableBody = ({
    wId,
    stocksList,
    setShowTransfer,
    setShowComing,
    setShowPaymentsId,
    setShowPaymentsTitle,
    setShowStockLots,
    stockLots = null,
    fetchStocks,
    onlyView,
    showBalanceColumn = false,
}: WarehouseTableBodyProps) => {
    const { showCategory, showArticle, showUpdated } = useWarehouse();
    const colSpan = 2
        + (showCategory ? 1 : 0)
        + (showArticle ? 1 : 0)
        + (showUpdated ? 1 : 0)
        + (onlyView ? 0 : 1)
        + (showBalanceColumn ? 1 : 0);

    return (<>
        <tbody>
        {stocksList && stocksList?.map((stock) => {
            return (
                <StockTableRows
                    wId={wId}
                    onlyView={onlyView}
                    setShowTransfer={setShowTransfer}
                    setShowComing={setShowComing}
                    setShowPaymentsId={setShowPaymentsId}
                    setShowPaymentsTitle={setShowPaymentsTitle}
                    setShowStockLots={setShowStockLots}
                    stockLots={stockLots}
                    fetchStocks={fetchStocks}
                    key={stock.ID} 
                    stock={stock}/>
            )
        })}

        
        {(!stocksList || stocksList.length === 0) && (
            <tr>
                <td colSpan={colSpan}>
                    <EmptyResult/>
                </td>
            </tr>)}
        </tbody>
        
    </>) 
}

export default WarehouseTableBody;
